import { ResourceType } from '../../../typings/permissions';
import type { ProjectActions, ProjectAnyActions } from '../../../typings/permissions';

import { useHasPermission } from '.';

/**
 * Helper hook for checking user's Project permissions.
 * @param projectId - The Project ID to check project permissions for.
 * @param action - The action to check for.
 * @returns Whether the user has the given permission for the given project.
 */
const useHasProjectPermission = (
  projectId: string,
  action: ProjectActions | ProjectAnyActions,
): boolean => {
  const hasPermission = useHasPermission();

  return (
    hasPermission({
      resourceType: ResourceType.ProjectAny,
      action: action as ProjectAnyActions,
    }) ||
    hasPermission({
      resourceType: ResourceType.Project,
      action: action as ProjectActions,
      projectId,
    })
  );
};

export default useHasProjectPermission;
